var _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 281,
    viewBox: "0 0 1280 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494 280.5C502.836 280.5 510 273.337 510 264.5L510 136.001C510 122.746 520.745 112.001 534 112.001L582 112.001C590.836 112.001 598 104.837 598 96.0008L598 15.9999C598 7.16336 590.836 -6.0722e-05 582 -6.03358e-05L24.0001 0.000116643C10.7452 0.000117222 4.92438e-05 10.7454 0.000110858 24.0002L0.000974617 236L0.000548267 256.5C0.000243671 269.755 10.7455 280.5 24.0005 280.5L494 280.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 128C1019.58 128 1016 124.418 1016 120C1016 115.582 1019.58 112 1024 112L1016 112L1016 128L1024 128Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1016,
    y: 128,
    width: 16,
    height: 18,
    transform: "rotate(180 1016 128)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M992 128C996.418 128 1000 124.418 1000 120C1000 115.582 996.418 112 992 112L1000 112L1000 128L992 128Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M598 72.0001C598 67.5818 601.582 64.0001 606 64.0001C610.418 64.0001 614 67.5818 614 72.0001L614 64.0001L598 64.0001L598 72.0001Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 64.0001,
    width: 16,
    height: 18,
    stroke: "white",
    transform: "rotate(-90 598 64.0001)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M598 40.0001C598 44.4183 601.582 48.0001 606 48.0001C610.418 48.0001 614 44.4183 614 40.0001L614 48.0001L598 48.0001L598 40.0001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M542 280.5L1264 280.5C1272.84 280.5 1280 273.337 1280 264.5L1280 16.0001C1280 7.16357 1272.84 0.000120757 1264 0.000119138L630 2.93262e-06C621.163 0 614 7.16344 614 16V104C614 117.255 603.255 128 590 128H542C533.163 128 526 135.163 526 144V264.5C526 273.337 533.163 280.5 542 280.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsBg);
export default __webpack_public_path__ + "static/media/results_bg.49a84726298e9517a05feb2b193009f8.svg";
export { ForwardRef as ReactComponent };